import React from "react";
import PropTypes from "prop-types";
// Limitless imports
import Grid from "@limitless/modern/layout/Grid";
import Paper from "@limitless/modern/surfaces/paper/Paper";
import Typography from "@limitless/modern/data-display/typography/Typography";
import DropdownMenu from "@limitless/modern/inputs/dropdown-menu/DropdownMenu";
import WithdrawlHistoryItem from "./WithdrawlHistoryItem";
import { LoadingSpinner } from "@limitless/portal";
import { locale as translatableLocale } from "@limitless/common/utils";
import { useExpertPaymentsContext, useExpertProfileContext } from "@limitless/expert";

const WithdrawlHistory = ({ t }) => {
    const [selectedYear, setSelectedYear] = React.useState(null);
    const [years, setYears] = React.useState([]);

    const locale = React.useMemo(() => translatableLocale(t, true), []);
    const { formatDate } = useExpertProfileContext();
    const { payments } = useExpertPaymentsContext();
    const { history } = payments;
    const { loading } = payments;

    let lastMonthHeader = "";

    return (
        <Paper
            sx={{ maxWidth: "unset", minHeight: "100%", height: "calc(100vh - 353px)", overflow: "hidden" }}
            elevation={2}
        >
            <Grid container sx={{ rowGap: theme => theme.spacing(2), padding: 3, paddingBottom: 1.5 }}>
                <Grid item xs={8}>
                    <Grid
                        item
                        container
                        xs={12}
                        color="text.primary"
                        component={Typography}
                        variant="h6"
                        sx={{
                            rowGap: theme => theme.spacing(1)
                        }}
                    >
                        Withdrawal History
                    </Grid>
                </Grid>
                <Grid item xs={4}>
                    <Grid
                        container
                        justifyContent="flex-end"
                        sx={{ textAlign: "right", rowGap: theme => theme.spacing(1) }}
                        alignItems="flex-end"
                    >
                        <DropdownMenu
                            smallSize
                            options={years}
                            placeholder="Select"
                            selected={selectedYear}
                            onChange={(e, selectedValue) => setSelectedYear(selectedValue)}
                            skinny
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid
                container
                sx={{
                    padding: theme => theme.spacing(3),
                    paddingTop: 0,
                    paddingBottom: 0,
                    rowGap: theme => theme.spacing(3),
                    overflow: "auto",
                    height: "calc(100vh - 467px)"
                }}
            >
                <Grid item container sx={{ alignContent: "flex-start" }}>
                    {loading ? (
                        <Grid item xs={12} variant="subtitle2" sx={{ paddingBottom: 1,textAlign:"center" }} alignItems="center" >
                            <LoadingSpinner color = "primary" />
                        </Grid>
                    ) : history.length === 0 ? (
                        <Grid
                            item
                            xs={12}
                            component={Typography}
                            variant="subtitle2"
                            sx={{ paddingBottom: 1, textAlign: "center" }}
                            color="text.secondary"
                        >
                            No withdrawal history available
                        </Grid>
                    ) : (
                        <>
                            {/* eslint-disable-next-line consistent-return */}
                            {history.map((value, index) => {
                                const rdataDate = formatDate(value.date, locale, true);
                                const thisDate = new Date(value.date);
                                const month = thisDate.toLocaleString("default", { month: "long" });
                                const year = thisDate.getFullYear();
                                const header = lastMonthHeader !== month ? month : "";
                                lastMonthHeader = month;
                                const yearExists = years.filter(e => e.label === `${year}`).length > 0;
                                if (!yearExists) {
                                    if (years.length === 1) {
                                        const newYears = [...years, { label: `${year}`, value: year }];
                                        setYears([{ label: "All", value: null }, ...newYears]);
                                    } else {
                                        setYears([...years, { label: `${year}`, value: year }]);
                                    }
                                }
                                if (selectedYear === null || selectedYear.value === null) {
                                    return (
                                        <WithdrawlHistoryItem
                                            item={value}
                                            key={index}
                                            header={header}
                                            rdataDate={rdataDate}
                                            index={index}
                                        />
                                    );
                                } else if (year === selectedYear.value) {
                                    return (
                                        <WithdrawlHistoryItem
                                            item={value}
                                            key={index}
                                            header={header}
                                            rdataDate={rdataDate}
                                            index={index}
                                        />
                                    );
                                }
                            })}
                        </>
                    )}
                </Grid>
            </Grid>
        </Paper>
    );
};

WithdrawlHistory.propTypes = {
    t: PropTypes.func.isRequired
};

export default WithdrawlHistory;
